import axios from 'axios'
import {API_URL} from '../../../tenant/apiBase'
import {getOffers} from '../../offers/cors/_requests'
import {
  ICreateStockRequestPayload,
  ICreateStockRequestResponse,
  IStockRequestDetails,
  IStockRequestListFilters,
  IStockRequestListResponse,
} from './_models'

const BASE = `${API_URL}/api/partner-portal/stock-requests`

function authHeaders(token?: string, language?: string) {
  return {token: token || '', language: language || 'en'}
}

export function searchOwnOffers(
  params: {search?: string; page: number; limit: number},
  token?: string,
  language?: string
) {
  return getOffers(
    {search: params.search || undefined, page: params.page, limit: params.limit},
    token,
    language
  )
}

export function createStockRequest(
  payload: ICreateStockRequestPayload,
  token?: string,
  language?: string
) {
  return axios.post<ICreateStockRequestResponse>(BASE, payload, {
    headers: authHeaders(token, language),
  })
}

export function getStockRequests(
  filters: IStockRequestListFilters,
  token?: string,
  language?: string
) {
  const qs = new URLSearchParams()
  if (filters.page) qs.set('page', String(filters.page))
  if (filters.limit) qs.set('limit', String(filters.limit))
  if (filters.status) qs.set('status', filters.status)
  const s = qs.toString()
  return axios.get<IStockRequestListResponse>(`${BASE}${s ? `?${s}` : ''}`, {
    headers: authHeaders(token, language),
  })
}

export function getStockRequest(requestId: number, token?: string, language?: string) {
  return axios.get<{data: IStockRequestDetails}>(`${BASE}/${requestId}`, {
    headers: authHeaders(token, language),
  })
}

export function getUnseenStockRequestsCount(token?: string, language?: string) {
  return axios.get<{data: {count: number}}>(`${BASE}/unseen-count`, {
    headers: authHeaders(token, language),
  })
}

export function markStockRequestsSeen(token?: string, language?: string) {
  return axios.post<{data: {updated: number}}>(
    `${BASE}/seen`,
    {},
    {headers: authHeaders(token, language)}
  )
}
